import { Header } from 'components/Header';
import { Footer } from 'components/Footer';
import { EditUserForm } from 'components/Forms';

export function EditUser() {
  return (
    <>
      <Header />
      <EditUserForm />
      <Footer />
    </>
  );
}
